module.exports = __webpack_public_path__ + "media/dog-profile-avatars/single-labrador-retriever-49b10c1e.svg";